var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundElementChromeExtentions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 959.31 643.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e05960bc-d5f5-419e-8cbc-b52fe8bc53b7{opacity:0.1;}.feb9207d-f437-47ed-9942-e83f7f95a701{fill:#0fc571;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a2a6e6a8-0bd9-4f11-bbdf-6109db354eb7",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bc8d1575-ada2-4efb-ab5d-cd43ce7aa9db",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2d574ee-73c1-4e27-a332-c2c386d1fdcd",
    "data-name": "Shape 9 copy 3-3",
    className: "e05960bc-d5f5-419e-8cbc-b52fe8bc53b7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bc5c67ec-2477-4c87-bfc8-defc11c570b4",
    "data-name": "Shape 9 copy 3-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "feb9207d-f437-47ed-9942-e83f7f95a701",
    d: "M699.89,199.88S543.27-32.92,318.11,4c0,0-547.7,96.93-205.78,516.08,0,0,209.9,220.29,436.79,71.82,0,0,140.17-75.25,194.94-54.22,0,0,146.43-.75,196.53-67.13C940.6,470.51,1059.06,354.57,699.89,199.88Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundElementChromeExtentions);
export default __webpack_public_path__ + "static/media/background-element-chrome-extentions.667fb5aa9da997ec530149a38162d11e.svg";
export { ForwardRef as ReactComponent };